import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { LogOut } from 'lucide-react'
import { usePageInfo } from 'app/frontend/base/config/queries'
import UserSubheader from './UserSubheader'
import { cn } from '@/lib/utils'
import { useHasSidebar } from 'app/frontend/base/hooks/useHasSidebar'

const UserHeader = () => {
  const { t } = useTranslation()
  const {
    data: { user },
  } = usePageInfo()
  const hasSidebar = useHasSidebar()

  return (
    <>
      <header className='w-full border-b-2'>
        <div
          className={cn(
            'root-width sm:h-[5.1rem] flex items-end pb-4',
            hasSidebar && 'mx-0',
          )}
        >
          <div className='grow flex justify-between items-center'>
            <h1 className='flex flex-col'>
              <span
                className={`text-base text-muted-foreground capitalize h-[1.6rem] leading-6 font-normal`}
              >
                {t('header.profile')}
              </span>
              <div>{user?.battletag.split('#')?.[0]}</div>
            </h1>
            <div className='flex gap-2'>
              <a href='/logout'>
                <Button variant='outline' className='flex gap-2'>
                  <LogOut width={14} />
                  {t('header.log-out')}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </header>
      <UserSubheader />
    </>
  )
}

export default UserHeader
